const $map = $("#main-map");

function initGoogleMap() {
  if (!$map.length) return;
  const script = document.createElement("script");
  script.src =
    "https://maps.googleapis.com/maps/api/js?key=AIzaSyD_nq9lgtccB6F2BBsjCs-wfzhCbdsl3xo&callback=initMap&language="+window.language;
  script.defer = true;
  document.head.appendChild(script);
}

window.initMap = function () {
  let map;
  let marker;
  if (!$map.length) return;
  const lat = Number($map.attr("data-lat"));
  const lng = Number($map.attr("data-lng"));
  const title = $map.attr("data-text") || "";
  const mapCenter = { lat: lat || 0, lng: lng || 0 };
  map = new google.maps.Map($map.get(0), {
    center: mapCenter,
    disableDefaultUI: true,
    zoom: 15,
    draggable: true,
    zoomControl: true,
    scaleControl: false,
    scrollwheel: false,
    disableDoubleClickZoom: true,
  });
  marker = new google.maps.Marker({
    position: mapCenter,
    map: map,
    title: title,
    icon: {
      url: "dist/public/marker.png",
      scaledSize: new google.maps.Size(72, 72),
    },
  });
  marker.setMap(map);
};

initGoogleMap();
